import { Component, OnInit } from '@angular/core';
import { AuthService } from '@app/services';

@Component({
  selector: 'app-detached-login',
  templateUrl: './detached-login.component.html',
  styleUrls: ['./detached-login.component.scss'],
})
export class DetachedLoginComponent implements OnInit {
  constructor(private authService: AuthService) {}

  ngOnInit(): void {
    this.redirect();
  }

  private async redirect(): Promise<void> {
    try {
      const { url } = await this.authService.redirectSSO('sso-detached-logged-in');
      window.open(url, '_self');
    } catch (error) {
      console.error(error);
    }
  }
}
